import { MarkdownTextPrimitive } from '@assistant-ui/react-markdown';
import remarkGfm from 'remark-gfm';

import { remarkTableCsv } from '@atom/utilities/remarkUtilities';

import ChatMarkdownTable from './ChatMarkdownTable';

import classes from './chat.module.css';

const ChatMarkdown = () => {
  return (
    <MarkdownTextPrimitive
      remarkPlugins={[remarkGfm, remarkTableCsv]}
      components={{
        // eslint-disable-next-line id-length
        p: ({ children }) => (
          <p className={classes.markdownParagraph}>{children}</p>
        ),
        h1: ({ children }) => (
          <h1 className={classes.markdownH1}>{children}</h1>
        ),
        h2: ({ children }) => (
          <h2 className={classes.markdownH2}>{children}</h2>
        ),
        h3: ({ children }) => (
          <h3 className={classes.markdownH3}>{children}</h3>
        ),
        // eslint-disable-next-line id-length
        a: ({ children, href }) => (
          <a
            href={href}
            className={classes.markdownLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {children}
          </a>
        ),
        strong: ({ children }) => (
          <strong className={classes.markdownStrong}>{children}</strong>
        ),
        em: ({ children }) => (
          <em className={classes.markdownEm}>{children}</em>
        ),
        ol: ({ children }) => (
          <ol className={classes.markdownOl}>{children}</ol>
        ),
        ul: ({ children }) => (
          <ul className={classes.markdownUl}>{children}</ul>
        ),
        li: ({ children }) => (
          <li className={classes.markdownLi}>{children}</li>
        ),
        code: ({ children }) => (
          <code className={classes.markdownCode}>{children}</code>
        ),
        pre: ({ children }) => (
          <pre className={classes.markdownCodeBlock}>
            {/* @ts-ignore */}
            {children?.props?.children ? children.props.children : children}
          </pre>
        ),
        table: ({ children, ...props }) => (
          <ChatMarkdownTable {...props}>{children}</ChatMarkdownTable>
        ),
        thead: ({ children }) => (
          <thead className={classes.markdownThead}>{children}</thead>
        ),
        tbody: ({ children }) => (
          <tbody className={classes.markdownTbody}>{children}</tbody>
        ),
        tr: ({ children }) => <tr>{children}</tr>,
        th: ({ children }) => (
          <th className={classes.markdownTh}>{children}</th>
        ),
        td: ({ children }) => (
          <td className={classes.markdownTd}>{children}</td>
        ),
      }}
    />
  );
};

export default ChatMarkdown;
